import Controller from '@ember/controller';

export default class IndexController extends Controller {
  queryParams = ['preserveScrollPosition'];
  preserveScrollPosition = true;
}
